import { useEffect, useState } from 'react';
import { news } from '../services/news';

export const NEWS_SEEN_EVENT = 'stratsync:news-seen';

export function useUnreadNews(userId?: string) {
  const [state, setState] = useState({ userId, count: 0 });
  useEffect(() => {
    setState({ userId, count: 0 });
    if (!userId) return;
    let controller: AbortController | undefined;
    const refresh = () => {
      if (document.visibilityState !== 'visible') return;
      controller?.abort();
      const request = new AbortController(); controller = request;
      news.unread(request.signal).then(result => {
        if (!request.signal.aborted) setState({ userId, count: result.count });
      }).catch(() => { /* Keep the last known state on transient network errors. */ });
    };
    refresh();
    const timer = window.setInterval(refresh, 60_000);
    window.addEventListener('focus', refresh);
    window.addEventListener(NEWS_SEEN_EVENT, refresh);
    document.addEventListener('visibilitychange', refresh);
    return () => {
      controller?.abort(); window.clearInterval(timer);
      window.removeEventListener('focus', refresh);
      window.removeEventListener(NEWS_SEEN_EVENT, refresh);
      document.removeEventListener('visibilitychange', refresh);
    };
  }, [userId]);
  return state.userId === userId ? state.count : 0;
}
